module.exports = __webpack_public_path__ + "images/emoji/pager.9a474eddedef1aa37441.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pager.png
// module id = fcXP
// module chunks = 2